import classes from './styles.module.css';
import Button from '../../../components/common/Button';
import { useForm } from 'react-hook-form';
import { usePostPasswordResetEmailMutation } from '../../../api/loginApi';
import { useNavigate } from 'react-router';
import {
  max,
  mistakeMailaddressMessage,
  requiredByMailaddressMessage,
} from '../../../message';
import FormBlockItem from '../../../components/common/FormBlockItem';
import LoginLayout from '../../../components/LoginLayout';
import { logger } from '../../../services/logger';

function PasswordResetMail() {
  const navigate = useNavigate();

  const MailaddressValidation = {
    required: requiredByMailaddressMessage,
    maxLength: {
      value: 255,
      message: max('メールアドレス', 255),
    },
    validate: (value: string) => {
      return value.indexOf('@') !== -1 || mistakeMailaddressMessage;
    },
  };

  const [postPasswordResetEmail] = usePostPasswordResetEmailMutation();

  const form = useForm({ mode: 'onBlur' });
  const { register } = form;

  return (
    <LoginLayout
      title="パスワード再設定"
      titleHeightIsTheSameAsLogo
      goBack="login"
    >
      <form
        onSubmit={form.handleSubmit(async (data) => {
          await postPasswordResetEmail({ email: data.email })
            .unwrap()
            .then(() => {
              navigate('./sent-mail');
            })
            .catch(logger.error);
        })}
      >
        <div className={classes.Comment}>
          ご登録時のメールアドレスを入力してください。
          <br />
          パスワード再設定用のメールを送信します。
        </div>
        <div>
          <FormBlockItem
            label="メールアドレス(ログインID)"
            type="email"
            placeholder="you@example.com"
            autoComplete="email"
            {...register('email', MailaddressValidation)}
            error={
              form.formState.errors.email
                ? String(form.formState.errors.email.message)
                : undefined
            }
          />
        </div>
        <div className={classes.Button}>
          <Button
            variants={['fit']}
            type="submit"
            disabled={!form.formState.isValid}
          >
            送信する
          </Button>
        </div>
      </form>
    </LoginLayout>
  );
}

export default PasswordResetMail;
